// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"widget_wrapper__1_NhL","customWidget":"widget_customWidget__232e7"};